import { AxiosResponse } from "axios";

import apiClient from "../../../../shared/infrastructure/api/client";
import type { CenterIntakeProfile, IntakeProfile, IntakeProfileInput } from "../../domain/IntakeProfile";

export const IntakeProfileAPI = {
    get: (patientId: string): Promise<AxiosResponse<IntakeProfile>> =>
        apiClient.get(`/patients/${patientId}/intake-profile`),

    save: (patientId: string, values: IntakeProfileInput): Promise<AxiosResponse<IntakeProfile>> =>
        apiClient.put(`/patients/${patientId}/intake-profile`, { values }),

    /** `value` is the therapist's edit; absent to keep what was proposed. */
    accept: (patientId: string, suggestionId: string, value?: string): Promise<AxiosResponse<IntakeProfile>> =>
        apiClient.post(
            `/patients/${patientId}/intake-profile/suggestions/${suggestionId}/accept`,
            value === undefined ? {} : { value },
        ),

    dismiss: (patientId: string, suggestionId: string): Promise<AxiosResponse<IntakeProfile>> =>
        apiClient.post(`/patients/${patientId}/intake-profile/suggestions/${suggestionId}/dismiss`),
};

/** The profile of a patient a centre holds, for its administrators: values only. */
export const CenterIntakeProfileAPI = {
    get: (centerId: string, patientId: string): Promise<AxiosResponse<CenterIntakeProfile>> =>
        apiClient.get(`/centers/${centerId}/patients/${patientId}/intake-profile`),

    save: (centerId: string, patientId: string, values: IntakeProfileInput): Promise<AxiosResponse<CenterIntakeProfile>> =>
        apiClient.put(`/centers/${centerId}/patients/${patientId}/intake-profile`, { values }),
};
